'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioSVG = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _componentThemes$form = _themes.componentThemes.form,
  classicRadioStyle = _componentThemes$form.classicRadioStyle,
  formTheme = _componentThemes$form.formTheme;
var labelStyles = function labelStyles(_ref) {
  var theme = _ref.theme;
  return {
    borderBottom: theme.border,
    padding: theme.space_xs + ' 0',
    display: 'flex',
    cursor: 'pointer'
  };
};
var Label = (0, _glamorous2.default)('label')(labelStyles);
Radio.propTypes = {
  selected: _propTypes.bool,
  theme: _propTypes.object.isRequired
};
Radio.defaultProps = {
  selected: false
};
function Radio(props) {
  var theme = formTheme(props.theme);
  return _react2.default.createElement(_glamorous2.default.Svg, {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 25.17 25.17',
    margin: theme[classicRadioStyle('marginTop')] + ' 10px 0 0',
    width: '20px',
    minWidth: '20px',
    height: '20px',
    minHeight: '20px'
  }, _react2.default.createElement('title', null, 'Radio Button'), _react2.default.createElement('g', null, _react2.default.createElement('circle', {
    cx: '12.58',
    cy: '12.58',
    r: '12.08',
    fill: theme[classicRadioStyle('backgroundColor', props.selected ? 'selected' : undefined)]
  }), _react2.default.createElement('path', {
    d: 'M12.58,25.17A12.58,12.58,0,1,1,25.17,12.58,12.6,12.6,0,0,1,12.58,25.17ZM12.58,1A11.58,11.58,0,1,0,24.17,12.58,11.6,11.6,0,0,0,12.58,1Z',
    fill: theme[classicRadioStyle('color', props.selected ? 'selected' : undefined)]
  })), props.selected && _react2.default.createElement('circle', {
    cx: '12.58',
    cy: '12.58',
    r: '6.5',
    fill: theme[classicRadioStyle('color', 'selected')]
  }));
}
var RadioSVG = exports.RadioSVG = (0, _glamorous.withTheme)(Radio);
var RadioClassic = function (_Component) {
  _inherits(RadioClassic, _Component);
  function RadioClassic() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, RadioClassic);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = RadioClassic.__proto__ || Object.getPrototypeOf(RadioClassic)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOnChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RadioClassic, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        value = _props.value,
        text = _props.text,
        selected = _props.selected,
        name = _props.name;
      var inputName = name + '_' + value;
      return _react2.default.createElement(Label, {
        key: value
      }, _react2.default.createElement(_glamorous2.default.Input, {
        type: 'radio',
        name: inputName,
        value: value,
        onChange: this.handleOnChange,
        checked: selected,
        display: 'none'
      }), _react2.default.createElement(RadioSVG, {
        selected: selected
      }), _react2.default.createElement('div', null, text));
    }
  }]);
  return RadioClassic;
}(_react.Component);
RadioClassic.propTypes = {
  value: _propTypes.string.isRequired,
  text: _propTypes.string.isRequired,
  selected: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  name: _propTypes.string.isRequired
};
RadioClassic.defaultProps = {
  selected: false
};
exports.default = RadioClassic;